import { useMsal } from '@azure/msal-react';
import { useMemo } from 'react';

import { createMsalAuthApi } from './msal';

import type { EntraConfig } from './msal';
import type { AuthApi } from './types';

/** Adapts the MSAL React context to the site's `AuthApi`. */
export function useMsalAuthApi(config: EntraConfig): AuthApi {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0] ?? null;
  return useMemo(() => createMsalAuthApi(instance, account, config), [instance, account, config]);
}
